<script setup lang="ts">
import { EighteenPlus } from 'assets/data/icons';
const Icon = useIcon();
</script>
<template>
  <Icon :path="EighteenPlus" :size="28" filled />
</template>
